import React from 'react';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
import { RotatingLines } from 'react-loader-spinner';

/** @type {React.FC<import('react-loader-spinner').RotatingLines>} */
const PageLoader = ({ height = 140, width = 140, className, color = '#005090', ...rest }) => (
  <div className={classNames(className, 'absolute top-half left-half translate-center')}>
    <Helmet>
      <title>Loading...</title>
    </Helmet>
    <RotatingLines
      visible
      height={height}
      width={width}
      strokeColor={color}
      strokeWidth="5"
      animationDuration="1"
      ariaLabel="Loading..."
      {...rest}
    />
  </div>
);

export default PageLoader;
